import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { ConversationMessage } from '../../types/conversation.js';

@customElement('cp-chat-message')
export class CpChatMessage extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Object }) message!: ConversationMessage;

  private _formatTime(iso: string): string {
    try {
      const d = new Date(iso);
      return d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    } catch {
      return '';
    }
  }

  render() {
    const { message } = this;
    if (!message) return html``;

    const isUser = message.role === 'user';
    const roleLabel = isUser ? 'Du' : 'AI';

    return html`
      <div class="cp-chat-message ${isUser ? 'cp-chat-message--user' : 'cp-chat-message--assistant'}">
        <div class="cp-chat-message__role">${roleLabel}</div>
        <div class="cp-chat-message__bubble">
          <div class="cp-chat-message__content">${message.content}</div>
          <div class="cp-chat-message__time">${this._formatTime(message.created_at)}</div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-chat-message': CpChatMessage;
  }
}
